__turbopack_context__.v({
  "dialog_header": "report-dialog-module-scss-module__qcX7Oa__dialog_header",
});
